var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.data.html)?_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-auto",class:_vm.getSettings.className,domProps:{"innerHTML":_vm._s(_vm.data.html)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }